__turbopack_context__.v({
  "caption": "cD84Za_caption",
  "container": "cD84Za_container",
  "intro": "cD84Za_intro",
  "links": "cD84Za_links",
  "loading": "cD84Za_loading",
  "muiTextArea": "cD84Za_muiTextArea",
  "outro": "cD84Za_outro",
  "sendButton": "cD84Za_sendButton",
});
